export default __webpack_public_path__ + "static/media/Leardini.07470f32.png";